'use client';

import { useEffect, useState } from 'react';
import { isSearchBot } from '../isSearchBot';

export function useIsSearchBot(): boolean {
  const [isBot, setIsBot] = useState(false);

  useEffect(() => {
    const checkUserAgent = () => {
      if (typeof window !== 'undefined') {
        const userAgent = window.navigator.userAgent;
        const botResult = isSearchBot(userAgent);
        setIsBot(botResult);
      }
    };

    checkUserAgent();

    const interval = setInterval(checkUserAgent, 1000);

    return () => clearInterval(interval);
  }, []);

  return isBot;
}
